// Constants
import { CreateTaskFromMessageDialogWidth } from "@ms/uno-constants/lib/local/UIConstants";
// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
import { styleScrollbar } from "@ms/uno-controls/lib/local/utilities/Mixin.styles";
/**
 * Get styles for the createTaskFromMessage shell using Fluent UI v9
 */ export const useCreateTaskFromMessageShellStyles = makeStyles({
    root: {
        maxHeight: "100vh",
        maxWidth: "100vw",
        inset: "0px",
        position: "fixed",
        display: "flex",
        flexDirection: "column",
        ...styleScrollbar,
        backgroundColor: tokens.colorNeutralBackground1,
        alignItems: "anchor-center"
    },
    notificationBarContainer: {
        width: `${CreateTaskFromMessageDialogWidth}px`,
        position: "absolute",
        bottom: "0px"
    },
    spinner: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }
});
